export function ProgressLoader({
  size,
  percent,
  theme = "dark",
  type = "fill-up",
  fill = "transparent",
  loaderStrokeColor = "#1973FF",
  strokeColor = "#E5E8EA",
}: {
  size: number;
  percent: number;
  theme?: "light" | "dark";
  type?: "fill-up" | "empty-out" | "sign-up" | "reorder";
  fill?: string;
  loaderStrokeColor?: string;
  strokeColor?: string;
}) {
  const strokeWidth = size * 0.04;
  const radius = size / 2 - strokeWidth;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - percent * circumference;

  const baseStyle = {
    transformOrigin: `50% 50%`,
  };

  let opacity, dasharray, dashOffset;
  switch (type) {
    case "sign-up": {
      strokeColor = strokeColor ?? "#E5E8EA";
      opacity = 1;
      loaderStrokeColor = loaderStrokeColor ?? "#1973FF";
      dasharray = `${circumference} ${circumference}`;
      dashOffset = offset;

      break;
    }
    case "empty-out": {
      strokeColor = strokeColor ?? "#1973FF";
      opacity = 1;
      loaderStrokeColor = loaderStrokeColor ?? "#EBEDF3";
      dasharray = `${circumference}`;
      dashOffset = (circumference * (100 - percent)) / 100;

      break;
    }
    case "reorder": {
      strokeColor = strokeColor ?? "#EBEDF3";
      opacity = 1;
      loaderStrokeColor = loaderStrokeColor ?? "#1973FF";
      dasharray = `${circumference}`;
      dashOffset = (circumference * percent) / 100;

      break;
    }
    default: {
      strokeColor = theme === "dark" ? "#fff" : "#E5E8EA";
      opacity = theme === "dark" ? 0.3 : 1;
      loaderStrokeColor = loaderStrokeColor ?? "#FFB4C9";
      dasharray = `${circumference} ${circumference}`;
      dashOffset = offset;
    }
  }

  return (
    <svg width={size} height={size}>
      <circle
        stroke={strokeColor}
        opacity={opacity}
        strokeWidth={strokeWidth}
        fill={fill}
        r={radius}
        cx={size / 2}
        cy={size / 2}
        style={baseStyle}
      />
      <circle
        stroke={loaderStrokeColor}
        strokeWidth={strokeWidth}
        fill="transparent"
        r={radius}
        cx={size / 2}
        cy={size / 2}
        style={{
          strokeDasharray: dasharray,
          strokeDashoffset: dashOffset,
          transition: `stroke-dashoffset 0.35s`,
          transform: type === "reorder" ? `rotate(90deg) scaleX(-1)` : `rotate(-90deg)`,
          strokeLinecap: type === "reorder" ? "round" : "butt",
          ...baseStyle,
        }}
      />
    </svg>
  );
}
